<svg
  attr.width="{{ effectiveWidth() }}px"
  attr.height="{{ effectiveHeight() }}px"
  attr.fill="{{ fill() }}"
  attr.class="{{ class() }}"
  attr.viewBox="{{ viewBox() }}"
>
  <use attr.xlink:href="assets/icons/{{ icon() }}.svg#{{ icon() }}"></use>
</svg>
